import type { ComparativoUnidadesModel } from "../models/comparativoUnidadesModel"

export enum ComparativoUnidadesActionsTypes {
    CARREGAR = "CARREGAR",
}

type CarregarAction = {
    type: ComparativoUnidadesActionsTypes.CARREGAR
    payload: ComparativoUnidadesModel["registros"]
}

export type ComparativoUnidadesAction = CarregarAction
